import "core-js/modules/es.promise.finally.js";
import { useState, useContext, useCallback } from 'react';
import { AuthenticationContext } from '../context/AuthenticationProvider.js';
import { refreshToken, isTokenExpired, loginRedirect } from '../helpers/utils.js';
const useToken = () => {
  const [loading, setLoading] = useState(false);
  const {
    token,
    setToken,
    config
  } = useContext(AuthenticationContext);
  const refreshToken$1 = useCallback(async () => {
    setLoading(true);
    return refreshToken(token.refreshToken, config).finally(() => {
      setLoading(false);
    });
  }, [token, config]);
  const fetchToken = useCallback(async function () {
    let loginRedirectRequired = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var _a;
    if (isTokenExpired(token)) {
      setLoading(true);
      const newToken = await refreshToken(token.refreshToken, config);
      if (newToken) {
        setToken(newToken);
        return newToken;
      } else {
        if (loginRedirectRequired) {
          (_a = config.onBeforeLoginRedirect) == null ? void 0 : _a.call(config);
          await loginRedirect(config);
        }
      }
      setLoading(false);
    } else {
      return token;
    }
  }, [config, setToken, token]);
  return {
    loading,
    fetchToken,
    refreshToken: refreshToken$1
  };
};
export { useToken as default, useToken };